import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import Gallery from "@/components/site/Gallery";
import QuoteForm from "@/components/site/QuoteForm";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const Home = () => {
  return (
    <div className="grain bg-[#0A0A0A] text-white min-h-screen">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Gallery />
        <Process />
        <QuoteForm />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0F0F0F",
            border: "1px solid #2A2A2A",
            borderRadius: 0,
            color: "#fff",
            fontFamily: "JetBrains Mono, monospace",
            fontSize: "12px",
            letterSpacing: "0.1em",
          },
        }}
      />
    </div>
  );
}

export default App;
